
import amber from './amber';
import fontData from "./amber-font";
import CpuFactory from "6502.ts/lib/machine/cpu/Factory";
import keyboard from './keyboard';
import Rtc from "./rtc";
import Buf from "./BufferAdapter";
import RomBank from "./rom-data-bank";

function Ram(opts) {
    return Buf(opts);
}

function Rom(opts) {
    const rom = Buf(opts);
    rom.write = (address, value) => {};
    rom.reset = () => {};
    return rom;
}

function Machine(opts) {
    const ada = amber({
        columns: 80,
        rows: 25,
        frameRate: 60, // TODO get from config
        glyphBuffer: Buffer.from(fontData), // TODO remove this
        interruptLevelChanged: (i) => {
            //console.log("int", i);
            cpu.setInterrupt(i);
        }
    });

    const kbd = keyboard();
    const ram = Ram({ size: 0xd000 });
    const romBank = RomBank({ data: Buffer.from(opts.romBank)});

    const devices = [{
        address: 0x0,
        length: 0xc000,
        handler: ram
    }, {
        address: 0xc000,
        length: 0x100,
        handler: kbd
    }, {
        address: 0xc100,
        length: 0x100,
        handler: Rtc()
    }, {
        address: 0xc200,
        length: 0x200,
        handler: romBank
    }, {
        address: 0xd000,
        length: 0x1000,
        handler: ada
    }, {
        address: 0xe000,
        length: 0x2000,
        handler: Rom({ size: 0x2000, data: Buffer.from(opts.romData) })
    }];

    const deviceAt = (abs) => {
        const a = devices.filter(dev => abs >= dev.address && abs < dev.address + dev.length);
        if (a.length < 1) {
            //console.log("nodev");
            return {
                address: abs,
                length: 1,
                handler: {
                    read(addr) {
                        //return Math.floor(Math.random()*256) & 0xff;
                        return 0;
                    },
                    write(addr) {

                    }
                }
            }
            //throw `no device at ${abs}`;
        }
        return a[0];
    };

    const rel = (abs, dev) => {
        if (typeof dev === "undefined") {
            dev = deviceAt(abs);
        }

        return abs - dev.address;
    };

    const devRel = (abs, dev) => {
        if (typeof dev === "undefined") {
            dev = deviceAt(abs);
        }

        return {
            rel: rel(abs, dev),
            dev: dev
        };
    };

    const dispatch = (abs, method, val) => {
        //console.log(`${abs} ${method} ${val}`);
        const dr = devRel(abs);
        return dr.dev.handler[method](dr.rel, val);
    };

    const busInterface = {
        read: (address)             => dispatch(address, "read"),
        write: (address, value)     => dispatch(address, "write", value),
        peek: (address)             => dispatch(address, "read"),
        poke: (address, value)      => dispatch(address, "write", value),
        readWord(address) {
            return (this.read(address) | (this.read(address+1) << 8)) >>> 0;
        }
    };

    const invalidInstructionCallback = () => {
        if (opts.invalidInstructionCallback) {
            opts.invalidInstructionCallback();
        }
    };

    const cpu = new CpuFactory(CpuFactory.Type.stateMachine).create(busInterface);
    //const cpu = new CpuFactory(CpuFactory.Type.batchedAccess).create(busInterface);
    cpu.setInvalidInstructionCallback(invalidInstructionCallback);

    let elapsedClocks = 0;
    let intClocks = 0;

    const reset = () => {
        ada.reset();
        //ram.fill(0x00);
        cpu.reset();
        for (let d of devices) {
            if (typeof d.handler.reset !== "undefined") {
                d.handler.reset();
            }
        }
        elapsedClocks = 0;
        intClocks = 0;
    };

    const clk = () => {
        cpu.cycle();

        if (cpu.state.irq || cpu.state.nmi) {
            intClocks++;
        }
        elapsedClocks++;
    };

    const safeChar = (charCode) => {
        if (charCode >= 32 && charCode < 127) {
            return String.fromCharCode(charCode);
        } else {
            return ".";
        }
    };

    const dump = (from, length) => {
        if (typeof length === "undefined") {
            length = 64;
        }
        
        const d = [];
        for (let i = from; i < from + length; i++) {
            d.push(busInterface.read(i));
        }

        const lines = [];
        const bytesPerRow = 16;
        const wordsPerRow = bytesPerRow / 2;
        for (let i = 0; i < d.length; i+=bytesPerRow) {
            const rowBytes = d.slice(i, i+bytesPerRow);
            const addr = (from + i).toString(16)
                .padStart(4, "0");
            const bytes = rowBytes
                .map(b => b.toString(16).padStart(2, "0"));
            const bytesFirstHalf = bytes.slice(0, wordsPerRow).join(" ");
            const bytesSecondHalf = bytes.slice(wordsPerRow, bytes.length).join(" ");
            const text = rowBytes
                .map(safeChar)
                .join("");
            
            const line = `${addr}   ${bytesFirstHalf}  ${bytesSecondHalf}   ${text}`;
            lines.push(line);
            // console.log(line);
        }
        return lines.join("\n");
    };

    const nmi = () => {
        cpu.nmi();
    };


    return {
        reset: reset,
        clk: clk,
        bus: busInterface,
        cpu: cpu,
        ada: ada,
        dump: dump,
        keyboard: kbd,
        nmi: nmi,
        ram: ram,
        dump: dump,

        getElapsedClocks() { return elapsedClocks; },
        getIntClocks() {return intClocks;}
    }
}

export default Machine;


// WEBPACK FOOTER //
// ./src/emu/machine.js